import type { ChatMessage } from '../../../types/admin';

const EDIT_WINDOW_MS = 15 * 60 * 1000;
const USER_DELETE_WINDOW_MS = 48 * 60 * 60 * 1000;

function ageMs(message: ChatMessage, now: number): number {
  const created = Date.parse(message.created_at);
  if (Number.isNaN(created)) {
    return Number.POSITIVE_INFINITY;
  }
  return now - created;
}

export function canEditMessage(
  message: ChatMessage,
  currentUserId: string | null | undefined,
  now: number = Date.now(),
): boolean {
  if (!currentUserId) {
    return false;
  }
  if (message.message_type !== 'text') {
    return false;
  }
  if (message.sender_user_id !== currentUserId) {
    return false;
  }
  if (message.id.startsWith('tmp-')) {
    return false;
  }
  return ageMs(message, now) <= EDIT_WINDOW_MS;
}

export function canDeleteMessage(
  message: ChatMessage,
  currentUserId: string | null | undefined,
  isAdmin: boolean,
  now: number = Date.now(),
): boolean {
  if (message.id.startsWith('tmp-')) {
    return false;
  }
  if (isAdmin) {
    return true;
  }
  if (!currentUserId || message.sender_user_id !== currentUserId) {
    return false;
  }
  return ageMs(message, now) <= USER_DELETE_WINDOW_MS;
}
